import type { EditorLocale } from './types.js';

export const de: EditorLocale = {
  toolbar: {
    undo: 'Rückgängig (Ctrl+Z)',
    redo: 'Wiederholen (Ctrl+Y)',
    textFormat: 'Textformat',
    paragraph: 'Absatz',
    heading: (level) => `Überschrift ${level}`,
    quote: 'Zitat',
    codeBlock: 'Code-Block',
    bold: 'Fett (Ctrl+B)',
    italic: 'Kursiv (Ctrl+I)',
    underline: 'Unterstrichen (Ctrl+U)',
    inlineCode: 'Inline-Code (Ctrl+`)',
    alignLeft: 'Linksbündig',
    alignCenter: 'Zentriert',
    alignRight: 'Rechtsbündig',
    justify: 'Blocksatz',
    bulletList: 'Aufzählungsliste',
    orderedList: 'Nummerierte Liste',
    insertLink: 'Link einfügen',
    insertImage: 'Bild einfügen',
    blockquote: 'Zitat',
    horizontalRule: 'Trennlinie',
    htmlSource: 'HTML-Quellcode anzeigen',
    calloutInfo: 'Hinweis: Info',
    calloutSuccess: 'Hinweis: Erfolg',
    calloutWarning: 'Hinweis: Warnung',
    calloutDanger: 'Hinweis: Gefahr',
    insertCallout: 'Hinweisbox einfügen',
  },
  statusBar: {
    words: 'Wörter',
    characters: 'Zeichen',
    htmlSource: 'HTML',
  },
  dialogs: {
    linkUrl: 'Link-URL:',
    openInNewTab: 'In neuem Tab öffnen?',
    imageUrl: 'Bild-URL:',
    imageAlt: 'Alternativtext (optional):',
  },
  plugins: {
    ai: {
      panelTitle: 'KI-Assistent',
      noSelection: '(Kein Text ausgewählt — gesamtes Dokument wird verwendet)',
      customPromptPlaceholder: 'Eigene Anweisung eingeben…',
      runButton: 'Ausführen',
      applyButton: 'Übernehmen',
      generating: '⏳ Wird generiert…',
      noApiKey: '⚠️ Kein API-Key konfiguriert. Übergib apiKey oder endpoint beim Erstellen des Plugins.',
      errorPrefix: '❌ Fehler: ',
      actions: {
        improve: 'Verbessern',
        shorten: 'Kürzen',
        expand: 'Erweitern',
        summarize: 'Zusammenfassen',
        toGerman: '🇩🇪 Auf Deutsch',
        toEnglish: '🇬🇧 To English',
      },
    },
    emoji: {
      buttonTitle: 'Emoji einfügen',
      categories: {
        faces: 'Gesichter',
        hearts: 'Herzen',
        gestures: 'Gesten',
        nature: 'Natur',
        food: 'Essen',
        objects: 'Objekte',
        symbols: 'Symbole',
      },
    },
  },
};
